import PageHero from "../components/PageHero";
import GalleryGrid from "../components/GalleryGrid";

export default function Ocazie() {
  const IMAGINI = [1, 2, 3, 4, 5].map(n => `/images/ocazie/${n}.png`);

  return (
    <section>
      <PageHero title="Rochii de ocazie" subtitle="Pentru gale, botez, aniversări sau petreceri tematice." />
      <GalleryGrid items={IMAGINI} />
    </section>
  );
}
